import { SelectedDependencyWithClearHistoryProps } from '../dependencies/types';
import { SingleSelectFilterPopoverOption } from '../../common/filters/single-select-filter/SingleSelectFilterPopover';
import { DialogLoader } from '../../common/dialogs/DialogLoader';
import { OPTION_ALL } from '../../common/filters/single-select-filter/utils';
import { useUniversalSearchContext } from './UniversalSearchContext';
import { useState } from 'react';
import { UniversalSearchListItem } from './UniversalSearchListItem';
import { SalesforceItem } from '../../parser/ParserTypes';
import { SearchResultsList } from '../building-blocks/search/SearchResultsList';

interface UniversalSearchListProps {
  configurationItems: SalesforceItem[];
  onListItemClick: (props: SelectedDependencyWithClearHistoryProps) => void;
  activeItemId?: string;
  filterOptions: SingleSelectFilterPopoverOption[];
  onSelectedFilterItem: (key?: string) => void;
  selectedFilterValue?: string;
  showLoader?: boolean;
  isExpandedMode?: boolean;
  renderRightElement?: (item: SalesforceItem, isHovered: boolean) => React.ReactNode | null;
  getItemStyling?: (item: SalesforceItem) => object;
  forceRenderIcons?: boolean;
}

export const UniversalSearchList = ({
  configurationItems,
  onListItemClick,
  activeItemId,
  filterOptions,
  selectedFilterValue,
  onSelectedFilterItem,
  showLoader,
  renderRightElement,
  getItemStyling,
  forceRenderIcons,
  isExpandedMode,
}: UniversalSearchListProps) => {
  const { searchTxt } = useUniversalSearchContext();
  const [hoveredItemId, setHoveredItemId] = useState<string | null>(null);

  const selectedFilter = filterOptions.find(
    (filterOption) => filterOption.value === selectedFilterValue,
  );
  const activeFilterLabel =
    selectedFilter && selectedFilter.label !== OPTION_ALL.label ? selectedFilter.label : undefined;

  return (
    <>
      <DialogLoader visible={showLoader} variant="light" />
      <SearchResultsList
        items={configurationItems}
        renderItem={(_idx, item) => (
          <UniversalSearchListItem
            searchTxt={searchTxt}
            item={item}
            isExpandedMode={isExpandedMode ?? false}
            onListItemClick={onListItemClick}
            activeItemId={activeItemId ?? ''}
            hoveredItemId={hoveredItemId ?? ''}
            renderRightElement={renderRightElement ?? (() => null)}
            getItemStyling={getItemStyling ?? (() => ({}))}
            forceRenderIcons={forceRenderIcons ?? false}
            setHoveredItemId={setHoveredItemId}
          />
        )}
        activeFilterLabel={activeFilterLabel}
        onClearFilter={() => onSelectedFilterItem(undefined)}
      />
    </>
  );
};
